import { createAction, props } from '@ngrx/store';
import { IFilteredTransactionsRequest, IFilteredTransactionsResponse } from '../models/filtered-transactions.model';

export const loadFilteredTransactions = createAction(
  '[FilteredTransactions] Load Filtered Transactions',
  props<{ customerId: string; model: IFilteredTransactionsRequest }>()
);

export const loadFilteredTransactionsSuccess = createAction(
  '[FilteredTransactions] Load Filtered Transactions Success',
  props<{ response: IFilteredTransactionsResponse }>()
);

export const loadFilteredTransactionsFailure = createAction(
  '[FilteredTransactions] Load Filtered Transactions Failure',
  props<{ error: Error | any }>()
);